<span class="pill loyalty-score-bar"
      [ngClass]="pillClass()" *transloco="let t">
    <lib-loyalty-radial-bar [loyaltyScore]="loyaltyScore()" [loyaltyLevel]="loyaltyLevel()"
                           [size]="size()"></lib-loyalty-radial-bar>
  {{ t('loyaltyLevels.' + loyaltyLevel()) }}
</span>
